import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AppComponent } from 'app/app.component';
import * as _ from 'lodash';
import { environment } from 'environments/environment';
import { UserService } from 'shared/services/User/user.service';
import { PaymentService } from 'shared/services/Payment/payment.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { ViewScheduleComponent } from '../view-schedule/view-schedule.component';
import { MatDialog } from '@angular/material';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { ConnectTeamModalComponent } from '../connect-team-modal/connect-team-modal.component';
import { SeatViewModal } from '../seat-view-modal/seat-view-modal.component';
import { InputPromoModalComponent } from '../input-promo-modal/input-promo-modal.component';
import Swal from 'sweetalert2';
import { PackagePreviewComponent } from 'shared/reusable/package-preview/package-preview.component';
import { ConnectTicketmasterModal } from '../connect-tm/connect-tm.component';
import { VendorsService } from 'shared/services/SS-vendors/vendors.service';

declare const stripe: any;

@Component({
  selector: 'app-view-detail',
  templateUrl: './view-detail.component.html',
  styleUrls: ['./view-detail.component.scss']
})
export class ViewDetailComponent implements OnInit, AfterViewInit {
  teamId: string;
  publicGroups: any;
  loading: boolean;
  groupId: any;
  publicGroup: any;
  code: string;
  state: string;
  isStripeConnected: boolean;
  imageURL: string = environment.URL_TEAM_IMAGES;
  user: any;
  cardRef: any;
  isAlreadyMember: Boolean = false;
  isEmptyGroup: Boolean = false;
  widgetUrl: string= '';

  TIMEOUT; 

  isPromoApplied: Boolean = false;
  promoData = {
    description: '',
    new_fee: '',
    new_total: ''
  }
  currentPromo: any = false;

  gameCount: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private groupService: GroupService,
    private app: AppComponent,
    private payment: PaymentService,
    private userService: UserService,
    private alertService: AlertPopupService,
    private dialog: MatDialog,
    private tm: VendorsService,
    private data: DataSharingService,
    private vendor: VendorsService
  ) {
    this.route.queryParams.subscribe(params => {
      this.groupId = params.groupId;
      this.code = params.code;
      this.state = params.state;
    });
    const elements = stripe.elements();
    const style = {
      base: {
        color: '#32325d',
        fontFamily: 'Helvetica Neue, Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };
    this.cardRef = elements.create('card', { style: style });
    this.cardRef.addEventListener('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
    this.loading = true;
    this.groupService.getGroupDetails(this.groupId).subscribe(res => {
      this.publicGroup = res;
      this.teamId = this.publicGroup.season_ticket.team_id;
      this.gameCount = this.publicGroup.current_split
      if (Number(this.publicGroup.leader_uid) === 0 || !this.publicGroup.leader_uid) {
        this.isEmptyGroup = true;
      }
      this.isMemberOfGroup();
      if (Number(this.publicGroup.group_size) === this.publicGroup.group_members.length) {
        this.loading = false;
        this.alertService.errorAlertWithResult('This group is full. ', 'Go Back', `/new-group/public-groups/${this.teamId}`);
      } else {
        this.loading = false;
      }

      // this.TIMEOUT = setTimeout(() => {
      //   this.requestInfo();
      // }, 15000)
      this.didConnectTeamAccount()

      if(this.widgetUrl==''){
        this.vendor.getWidgetUrlByTeamName(this.teamId).subscribe(res => {
          this.widgetUrl=res.url;
        })
      }
    }, err => {
      this.loading = false;
      this.alertService.errorAlertWithResult(err.error.message, 'Go Back', '/new-group');
    });
    this.getGroupMembers()
  }

  //http://localhost:4200/new-group/public-groups/view-detail?groupId=81&code=693072374c99d9a95cb971ce1dc7b764ceffc128&state=seasonshare
  connectedAccountId=''
  ngOnInit() {
    this.userService.isLoggedIn();
    this.user = JSON.parse(localStorage.getItem('SSUserCookie'));
    localStorage.removeItem('groupIdAfterStripeCalling');
    if (this.code && this.code.length > 10 && this.state && this.state === 'seasonshare') {
      console.log("TEAM ID")
      console.log(this.teamId)
      this.tm.connectAccount(this.code, 144).subscribe(res => { // hard code remove TODO
        console.log(res)
        console.log("Conneceted ticketmaster")
        let a = res.validateRes.arch_member_id
        console.log(a)
        let b = a.split('.');
        this.connectedAccountId = b[1];  
        this.isTeamAccountConnected = true; 
      }, err => {
        this.isTeamAccountConnected = false; 
        console.log(err)
        this.alertService.errorAlert("Failed to connect your Team Account. Try again or contact support if the error persists. ")
      })
    } 
  
  }

  ngOnDestroy(){
    clearTimeout(this.TIMEOUT);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.isAlreadyMember) {
        this.cardRef.mount('#card-element');
      }
    }, 2300);
  }

  GROUP_MEMBERS = [];
  getGroupMembers(){
    this.groupService.getGroupMembers(this.groupId).subscribe(res => {
      this.GROUP_MEMBERS = res.group_members; 
    }, err => {
      console.log(err)
      alert('Failed to fetch group members ')
    })
  }

  inputPromoCode() {
    const dialogRef = this.dialog.open(InputPromoModalComponent, {
      width: '600px',
      data: {
        teamId: this.publicGroup.season_ticket.team_id
      }
    });
    dialogRef.afterClosed().subscribe(promoCode => {
      if (promoCode) {
        this.payment.checkPromo(this.groupId, promoCode).subscribe(res => {
          this.promoData = res.promo_applied;
          this.currentPromo = promoCode;
          this.isPromoApplied = true;
          this.alertService.errorAlertSuccess(`Score! We added a ${this.promoData.description} promo to your order.`);
        }, err => {
          this.alertService.errorAlertError(err.error.message);
        })
      }
    })
  }

  requestInfo() {
    clearTimeout(this.TIMEOUT);
    Swal.fire({
      imageUrl: 'assets/images/support.png',
      imageWidth: 100,
      imageAlt: 'Custom image',
      title: "Let us help you!",
      text: "Request a call from your dedicated Support Agent. Enter your phone number and we'll give you a call.",
      input: 'text',
      inputPlaceholder: "Phone Number",
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Request a call',
      showLoaderOnConfirm: true,
      preConfirm: (phoneNumber) => {
        let a = (Number.isInteger(Number(phoneNumber)));
        if(a == true){
          this.userService.requestGroupInfo(this.groupId, phoneNumber).then(res => {
            Swal.fire({
              title: `Thanks! We'll be in touch with you shortly. `,
              type: "success"
            })
            return res;
          }).catch(err => {
            Swal.fire({
              title: `Hmm. Something went wrong. Try again later. `,
              type: "error"
            })
          })
        } else {
          return Swal.fire({
            type: 'warning',
            title: 'Foul!'
          })
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
    })
  }

  back() {
    this.router.navigate(['new-group/public-groups'], { queryParams: { team_id: this.publicGroup.season_ticket.team_id } });
  }

  previewSeat() {
    // let seatViewURL = this.holdData.image_data;
    // let seatViewUrl = this.publicGroup.image_data;

    // const dialog = this.dialog.open(SeatViewModal, {
    //   width: '80%',
    //   height: '80%',
    //   data: {
    //     seatViewURL: seatViewUrl
    //   }
    // });
    // this.viewInSeat(this.publicGroup.image_data)
  }

  isTeamAccountConnected = false; 
  connectedAccount:any; 
  didConnectTeamAccount(){
    console.log("PUB GROUP")
    console.log(this.publicGroup)
      // this.tm.getTeamAccount(this.teamId).subscribe(res => {
      //   console.log(res)
      //   if(res.team_account){
      //     this.isTeamAccountConnected = true; 
      //     this.connectedAccount = res.team_account;
      //   }
      // }, err => {
      //   console.log(err)
      //   // this.alertService.errorAlertError("Failed to fetch team account");
      // })
  }
  // http://localhost:4200/new-group/public-groups/view-detail?code=2c554339d927a0046536a601dcd7124e4e386fbb&state=groupId120

  connectTeamAccount(){
    // modern accounts 
    const redirect_uri = `https://app.seasonshare.com/tmcallback/redirect`;
    // const redirect_uri = 'http://localhost:4200/new-group/public-groups/view-detail?groupId=81';
    // https://auth.ticketmaster.com/as/authorization.oauth2?lang=en-us&scope=openid profile archtics&client_id=3cd45dd01cc8.seasonshare.integ3-sandbox.us&integratorId=seasonshare&placementId=homepage&visualPresets=integ3&redirect_uri=${redirect_uri}&state=seasonshare
    this.widgetUrl = this.widgetUrl.replace('REDIRECT_URL', redirect_uri);
    this.widgetUrl = this.widgetUrl.replace('STATE', 'seasonshare');
    console.log(this.widgetUrl)
    window.open(this.widgetUrl,
      '_self');
  }
  removeTeamAccount(){
    this.tm.removeTeamAccountv2(this.teamId, this.connectedAccount.acct_id).subscribe(res => {
      this.alertService.errorAlertSuccess("Unlinked your team account");
      this.isTeamAccountConnected = false; 
      this.connectedAccount = null; 
    }, err => {
      this.alertService.errorAlertError("Failed to remove team account");
    })
  }

  purchaseSeason() {
    stripe.createToken(this.cardRef).then((result) => {
      if (result.error) {
        const errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
        this.loading = false;
      } else {
        // success! token generated
        const token = (result.token.id);
        if (this.userService.user.team_auths.filter(e => e.team_id_fk === this.publicGroup.season_ticket.team_id).length > 0) {
          // yes has auth, good to charge
          this.proceed(token);
        } else {
          // handle team account connection
          const dialogRef = this.dialog.open(ConnectTeamModalComponent, {
            width: '600px',
            data: {
              teamId: this.teamId
            }
          });
          // TO DO TO DO -----
          this.loading = false;
        }
      }
    });
  }

  proceed(token) {
    // TO DO - Utilize token
    this.app.toggleLoadingMsg('Joining Group');
    const amt = this.publicGroup.current_cost.toFixed(2);
    const order_number = this.publicGroup.season_ticket.tm_order_num_out;
    this.payment.joinPublicGroup(token, order_number, this.publicGroup.group_id, amt, this.currentPromo).subscribe(res => {
      this.groupService.refreshGroup(this.publicGroup.group_id).subscribe(response => {
        this.app.dismissLoading();
        if(response.group_status == "PENDING_CONFIRM"){
          // tickets processing, custom group
          this.alertService.purchaseSuccess("Your tickets are processing. Please allow 24-48 hours for them to appear in your Team Account. ");
        } else {
          // regular group, move to get ready 
          this.router.navigate(['/groups/get-ready'], { queryParams: { groupId: this.groupId } });
        }
      }, err => {
        this.app.dismissLoading();
        this.router.navigate(['/new-group']);
        this.alertService.errorAlert('An error occured when trying to refresh this group. Contact support.');
      });
    }, err => {
      console.log('error charging for join');
      console.log(err);
      this.app.dismissLoading();
      this.alertService.errorAlert('An error occured when trying to join this group. Contact support.');
    });
  }

  viewSchedule() {
    const dialogRef = this.dialog.open(ViewScheduleComponent, {
      data: {
        eventName: this.publicGroup.season_ticket.tm_event_name,
        teamImage: this.publicGroup.season_ticket.team_thumb_img,
        teamName: this.publicGroup.season_ticket.team_name_full,
        teamDescription: this.publicGroup.season_ticket.description
      },
      width: '70%',
    });
  }

  viewGames(){
    const dialogRef = this.dialog.open(PackagePreviewComponent, {
      data: {
        events: this.publicGroup.package_preview, 
        eventName: this.publicGroup.season_ticket.tm_event_name,
        teamImage: this.publicGroup.season_ticket.team_thumb_img,
        teamName: this.publicGroup.season_ticket.team_name_full,
        teamDescription: this.publicGroup.season_ticket.description
      },
      width: '70%',
    });
  }

  // Opens seat view
  viewInSeat(seatViewURL) {
    const dialog = this.dialog.open(SeatViewModal, {
      width: '80%',
      height: '80%',
      data: {
        seatViewURL: seatViewURL
      }
    });
  }

  goToLoginPage() {
    this.data.getGroupId(this.groupId);
    this.router.navigate(['/welcome'], { queryParams: { publicGroupId: this.publicGroup.group_id } });
  }
  groupLeaderFirstName = '';
  isMemberOfGroup() {
    _.each(this.publicGroup.group_members, (member) => {
      if (member.is_leader == "1") {
        this.groupLeaderFirstName = member.first_name;
      }
      if (member.uid === this.userService.user.uid) {
        this.isAlreadyMember = true;
        return;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/view-detail/view-detail.component.ts